import PartDetail from '@/models/Part/PartDetail';

export default class PartDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.supplierCodeId  = '';
		this.supplierCodeCode = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.supplierName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			supplierCodeId : '0',
			supplierCodeCode : '0',
			partId : '0',
			partPartNumber : '0',
			supplierName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}